import AppConstants from '../config/app.constants';

let DailyBalanceSheetService = function ($http, $q) {

    let getVaultBalance = (branchId, fundingSourceId, account, currencyId, vaultDate, manualDeposit) => {
        return $http
            .post(AppConstants.api + `/daily-balance-sheet/daily-vault-balance`, {
                branchId,
                fundingSourceId,
                account,
                currencyId,
                vaultDate,
                manualDeposit
            })
            .then((res) => {
                return res.data
            })
    }

    let vaultReport = (branchId, fundingSourceId, account, currencyId, vaultDate, branchTimezone, currencySymbol) => {
        return new Promise(function (resolve, reject) {
            var url = AppConstants.api + `/daily-balance-sheet/vault-report`;
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                branchId,
                fundingSourceId,
                account,
                currencyId,
                vaultDate,
                branchTimezone,
                currencySymbol: currencySymbol || '$'
            };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = branchId;
                    var date = moment(vaultDate).format('DDMMYY');
                    if (account === 'regular')
                        sheetName = `${reportPrefix}_vault_report_${date}.xlsx`;
                    else
                        sheetName = `${reportPrefix}_vault_report_${date}_emergency.xlsx`;

                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else {
                    var reader = new FileReader();
                    reader.onload = function () {
                        reject(reader.result);
                    };
                    reader.readAsText(new Blob([xhr.response]));
                }
            };

            xhr.send(JSON.stringify(data));
        });

    }

    let allDVBDetails = (branchId, fundingSourceId, currencyId, denominationId, account, vaultDate, infoFor) => {
        return $http
            .post(AppConstants.api + `/daily-balance-sheet/dvb-details`, {
                branchId,
                fundingSourceId,
                currencyId,
                denominationId,
                account,
                vaultDate,
                infoFor
            })
            .then((res) => {
                return res.data
            })
    };

    let exportData = (branchId, fundingSourceId, currencyId, denominationId, account, vaultDate, infoFor) => {
        return $http
            .post(AppConstants.api + `/daily-balance-sheet/export-details`, {
                branchId,
                fundingSourceId,
                currencyId,
                denominationId,
                account,
                vaultDate,
                infoFor
            }, ['receivedBulkCash', 'actualDepositsCounted'].includes(infoFor) ? { responseType: 'arraybuffer' } : {})
            .then((res) => {
                return res.data
            })
    };

    let getEarliestVaultDate = (branchId) => {
        return $http
            .get(AppConstants.api + `/daily-balance-sheet/get-earliest-vaultDate`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let emailVaultBalanceReport = (branchId, vaultDate, fundingSourceId) => {
        return $http
            .post(AppConstants.api + `/daily-balance-sheet/email-vault-balance-report`, {
                branchId,
                vaultDate,
                fundingSourceId
            })
            .then((res) => {
                return res.data
            })
    }

    let getVaultReportPrintData = (branchId, fundingSourceId, currencyId, vaultDate, branchTimezone) => {
        return $http
            .post(AppConstants.api + `/daily-balance-sheet/vault-report-print-data`, {
                branchId,
                fundingSourceId,
                currencyId,
                vaultDate,
                branchTimezone
            })
            .then((res) => {
                return res.data;
            });
    };

    return {
        getVaultBalance,
        vaultReport,
        allDVBDetails,
        exportData,
        getEarliestVaultDate,
        emailVaultBalanceReport,
        getVaultReportPrintData
    };
};

DailyBalanceSheetService.$inject = ['$http', '$q']

export default DailyBalanceSheetService;



// WEBPACK FOOTER //
// ./client/app/services/daily-balance-sheet.service.js